import {
    AGENT_STATUSES,
    CAMPAIGN_STATUSES,
} from '../../../../common/enums/enums';
import { Badge, Box, Group, Stack, Text, Tooltip } from '@mantine/core';
import { getEnumColor, getEnumLabel } from '../../../../../utils/enumUtils';

import { pascalToFriendly } from '../../../../../utils/text';

const CampaignCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const assignmentColor = getEnumColor(
        CAMPAIGN_STATUSES,
        rowData.assignment?.currentCampaignStatus
    );
    const agentStatusColor = getEnumColor(
        CAMPAIGN_STATUSES,
        rowData.assignment?.activityStatus
    );
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                {rowData.assignment ? (
                    <Tooltip
                        label={
                            <Group gap={4}>
                                <Text size={'sm'}>Status</Text>
                                <Badge
                                    size={'xs'}
                                    color={agentStatusColor}>
                                    {pascalToFriendly(
                                        rowData.assignment.activityStatus
                                    )}
                                </Badge>
                            </Group>
                        }>
                        <Badge
                            color={assignmentColor}
                            size={'xs'}>
                            {rowData.assignment.campaignName ||
                                'test-sms-campaign'}
                        </Badge>
                    </Tooltip>
                ) : (
                    <Badge
                        color={'teal.6'}
                        size={'xs'}>
                        Available
                    </Badge>
                )}
            </Stack>
        </Box>
    );
};

const CampaignColumn = () => ({
    accessorKey: 'campaignStatus',
    header: 'Campaign',
    size: 2,
    minSize: 100,
    Cell: ({ cell }) => <CampaignCell cell={cell} />,
});
export default CampaignColumn;
